// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:10:36

export default {
  "id": "turret-gunner",
  "slug": "turret-gunner",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/7d6904e6be5649a5a771cf41dcb76827-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/7d6904e6be5649a5a771cf41dcb76827/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Turret Gunner",
      "description": "You will find yourself in a thrilling air battle simulation, filled with exciting moments and countless enemy targets. You’ll be able to maneuver, shoot, and fight virtual opponents, experiencing the true adrenaline rush of an airstrike.\n\nThis captivating journey into the world of aviation will leave unforgettable impressions on fans of extreme action and flying. Feel like a real pilot and enjoy the excitement of aerial combat!\n\n\n\n\n\n\n",
      "instructions": "For PC Gameplay:\n\nLeft Mouse Button: Shoot\nRight Mouse Button: Launch Rocket\nSpacebar: Fire Howitzer\nMouse: Rotate Turret and Aim\nQ/E: Purchase Howitzer or Rocket during gameplay\nCtrl: Launch Rocket\n",
      "genres": [
        "Shooter",
        "Simulation"
      ],
      "tags": [
        "air",
        "battleship",
        "guns",
        "shoot-em-up",
        "weapons"
      ]
    },
    "zh-CN": {
      "title": "炮塔射手",
      "description": "你将置身于一场紧张刺激的空战模拟，充满激动人心的时刻和无数敌军目标。你将能够操控、射击，与虚拟对手战斗，体验空袭的真实肾上腺素飙升。\n\n这段引人入胜的航空世界之旅，将为极限动作和飞行爱好者留下难忘的印象。感受像真实飞行员一样，享受空中战斗的激情！",
      "instructions": "对于PC游戏玩法：\n\n左鼠标按钮：射击\n右鼠标按钮：发射火箭\n空格键：发射榴弹炮\n鼠标：旋转炮塔并瞄准\nQ/E键：游戏过程中购买榴弹炮或火箭\nCtrl键：发射火箭",
      "genres": [
        "射击",
        "模拟"
      ],
      "tags": [
        "空气",
        "战舰",
        "枪械",
        "射击游戏",
        "武器"
      ]
    },
    "zh-TW": {
      "title": "砲塔砲手",
      "description": "你將置身於刺激的空戰模擬遊戲，充滿令人興奮的瞬間和無數敵方目標。你可以操縱、射擊和與虛擬對手戰鬥，體驗真正的空襲刺激。這場迷人的航空之旅將為極限行動和飛行愛好者留下難忘的印象。感受像真實飛行員一樣的感覺，並享受空中戰鬥的刺激！",
      "instructions": "對PC遊戲操作：\n\n左鍵：射擊\n右鍵：發射火箭\n空格鍵：發射榴彈砲\n滑鼠：旋轉砲塔和對準目標\nQ/E鍵：遊戲中購買榴彈砲或火箭\nCtrl鍵：發射火箭",
      "genres": [
        "射擊",
        "模擬"
      ],
      "tags": [
        "空氣",
        "戰艦",
        "槍械",
        "射擊遊戲",
        "武器"
      ]
    },
    "zh-HK": {
      "title": "砲塔砲手",
      "description": "您將置身於刺激的空戰模擬中，充滿令人興奮的瞬間及無數敵方目標。您將能夠操控、射擊，並與虛擬對手戰鬥，體驗空襲的真實 adrenaline rush。這場引人入勝的飛航世界之旅將為極端行動和飛行愛好者留下難忘的印象。感受真實駕駛員的感覺，並享受空中作戰的刺激！",
      "instructions": "對PC遊戲操作：\n\n左鍵：射擊\n右鍵：發射火箭\n空格鍵：發射榴彈炮\n滑鼠：旋轉砲塔和對準目標\nQ/E：遊戲中購買榴彈炮或火箭\nCtrl：發射火箭",
      "genres": [
        "射擊遊戲",
        "模擬遊戲"
      ],
      "tags": [
        "空氣",
        "戰艦",
        "槍械",
        "射擊遊戲",
        "武器"
      ]
    },
    "ja": {
      "title": "タワー砲兵",
      "description": "興奮の空中戦闘シミュレーションに身を投じ、刺激的な瞬間と数え切れない敵のターゲットが満載です。操縦、撃ち、仮想の敵と戦い、空爆の本物のアドレナリン・ラッシュを体験できます。\n\nこの魅力的な航空の世界への旅は、過酷なアクションや飛行のファンに忘れられない印象を残します。本物のパイロットのような感じを味わい、空中戦闘の興奮を楽しみましょう！",
      "instructions": "PCゲームプレイ：\n\n左クリックボタン：射撃\n右クリックボタン：ロケット発射\nスペースバー：榴弾砲発射\nマウス：ターレットの回転と照準\nQ/E：ゲーム中に榴弾砲やロケットを購入\nCtrl：ロケット発射",
      "genres": [
        "射撃",
        "シミュレーション"
      ],
      "tags": [
        "空気",
        "戦艦",
        "銃",
        "シューティングアップ",
        "武器"
      ]
    },
    "ko": {
      "title": "타워 캐시어너",
      "description": "열血的 공중전 시뮬레이션에서 자신을 발견하게 되고, 흥미진진한 순간들과 무수한 적의 목표들로 가득 차 있습니다. 조종하고 발사하고 가상의 적과 싸우며 공습의 진정한 아드레날린 촉진을 경험할 수 있습니다.\n\n이 장면이 가득한 비행의 세계로의 매력적인 여정은 극단적인 행동과 비행을 사랑하는 팬들에게 잊을 수 없는 인상을 남길 것입니다. 진정한 조종사로서 공중전의 흥분을 즐겨보세요!",
      "instructions": "PC 플레이어블 게임:\n\n좌鼠标 버튼: 발사\n우鼠标 버튼: 로켓 발사\n스페이스바: 해포 발사\n마우스: 타워 회전 및 정면 조준\nQ/E: 게임 중 해포나 로켓 구매\nCtrl: 로켓 발사",
      "genres": [
        "射手",
        "시뮬레이션"
      ],
      "tags": [
        "공기",
        "전함",
        "총",
        "쏘아오라",
        "무기"
      ]
    },
    "fr": {
      "title": "Garnisonneur de tourelle",
      "description": "Vous vous retrouvez dans une simulation de combat aérien captivante, remplie de moments passionnants et de nombreux cibles ennemies. Vous pourrez manœuvrer, tirer et combattre des adversaires virtuels, expérimentant le véritable coup deadrine d'une attaque aérienne.\n\nCe voyage captivant dans le monde de l'aviation laissera des impressions inoubliables aux fans d'actions extrêmes et de vol. Sensation d'un pilote de vérité et profitez de l'excitation du combat aérien !",
      "instructions": "Pour le jeu sur PC :\n\nBouton gauche de la souris : Tirer\nBouton droit de la souris : Lancer un missile\nBarre d'espace : Tirer avec le howitzer\nSouris : Rotation de la tourelle et visée\nQ/E : Acheter un howitzer ou un missile pendant le jeu\nCtrl : Lancer un missile",
      "genres": [
        "Tir",
        "Simulation"
      ],
      "tags": [
        "air",
        "battleship",
        "canons",
        "shoot 'em up",
        "armes"
      ]
    }
  }
};
